import React, { Dispatch, SetStateAction } from 'react';
import { QRSetup } from './QRSetup';
import { Verification } from './Verification';
import { VerificationSuccess } from './VerificationSuccess';

interface TwoFAInitProps {
  step: number;
  setStep: Dispatch<SetStateAction<number>>;
  setIsOpen: Dispatch<SetStateAction<boolean>>;
}

export const TwoFAInit = ({ step, setStep, setIsOpen }: TwoFAInitProps) => {
  const renderSteps = (step: number) => {
    switch (step) {
      case 1:
        return <QRSetup setStep={setStep} />;

      case 2:
        return <Verification setStep={setStep} setIsOpen={setIsOpen} />;

      case 3:
        return <VerificationSuccess setIsOpen={setIsOpen} />;

      default:
        return <div></div>;
    }
  };
  return <div>{renderSteps(step)}</div>;
};
